import {
    EVENT_WELCOME_PAGE_NO_REDIRECT,
    EVENT_WELCOME_PAGE_OTHER_REDIRECT,
    EVENT_WELCOME_PAGE_REDIRECT
} from '@scandipwa/gtm-new/src/component/GoogleTagManager/GoogleTagManager.events';
import { event } from '@scandipwa/gtm-new/src/store/GoogleTagManager/GoogleTagManager.action';
import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';
import { connect } from 'react-redux';

import { showNotification } from 'Store/Notification/Notification.action';
import { closePopup, showPopup } from 'Store/Popup/Popup.action';
import { CountryType, HreflangsType, StoreCountriesType } from 'Type/Stores.type';
import { setCookie } from 'Util/Cookies/Cookies';
import history from 'Util/History';

import StoreRedirect from './StoreRedirect.component';
import {
    COM_SUB_STORE,
    COOKIE_LIFETIME,
    CURRENT_COUNTRY,
    DOT_COM,
    EXCLUDED_DOT_COM_STORES,
    NO_REDIRECT,
    STORE_REDIRECT_POPUP
} from './StoreRedirect.config';

import './StoreRedirect.style';

/** @namespace Bodypwa/Component/StoreRedirect/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    currentStoreCode: state.ConfigReducer.default_country,
    storeCountries: state.ConfigReducer.countries,
    hreflangs: state.MetaReducer.hreflangs,
    countries: state.StoresReducer.countries,
    isNoHreflangs: !!state.MetaReducer.isNoHreflangs,
    statusCode: state.ConfigReducer.statusCode,
    countryPopupDescription: state.ConfigReducer.country_popup_description
});

/** @namespace Bodypwa/Component/StoreRedirect/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    showErrorNotification: (message) => dispatch(showNotification('error', message)),
    showPopup: (id, payload) => dispatch(showPopup(id, payload)),
    closePopup: (id, payload) => dispatch(closePopup(id, payload)),
    event: (eventName = '', customData) => dispatch(event(eventName, customData))
});
/** @namespace Bodypwa/Component/StoreRedirect/Container */
export class StoreRedirectContainer extends PureComponent {
    static propTypes = {
        hreflangs: HreflangsType.isRequired,
        countries: PropTypes.arrayOf(CountryType).isRequired,
        redirectCountry: PropTypes.shape(CountryType),
        storeCountries: PropTypes.arrayOf(StoreCountriesType).isRequired,
        showPopup: PropTypes.func.isRequired,
        closePopup: PropTypes.func.isRequired,
        isNoHreflangs: PropTypes.bool.isRequired,
        currentStoreCode: PropTypes.string,
        statusCode: PropTypes.string.isRequired,
        countryPopupDescription: PropTypes.string.isRequired,
        isShowStoreSelect: PropTypes.bool.isRequired,
        event: PropTypes.func.isRequired
    };

    headerRef = createRef();

    static defaultProps = {
        currentStoreCode: 'default',
        redirectCountry: {
            label: '',
            names: [],
            code: '',
            url: ''
        }
    };

    state = {
        isShowPopUp: true
    };

    searchRef = createRef();

    containerFunctions = {
        goToShop: this.goToShop.bind(this),
        setDesiredCountry: this.setDesiredCountry.bind(this),
        onRedirect: this.onRedirect.bind(this)
    };

    containerProps() {
        const {
            countries,
            storeCountries,
            hreflangs,
            isNoHreflangs,
            redirectCountry,
            currentStoreCode,
            countryPopupDescription,
            isShowStoreSelect
        } = this.props;

        const {
            isShowPopUp
        } = this.state;

        return {
            countries,
            storeCountries,
            searchRef: this.searchRef,
            headerRef: this.headerRef,
            hreflangs,
            isNoHreflangs,
            selectedCountry: countries.filter((country) => country.code === currentStoreCode)[0] || {},
            redirectCountry,
            countryPopupDescription,
            isShowStoreSelect,
            isShowPopUp
        };
    }

    goToShop(selectedCountry) {
        const {
            url, locale, code, store_id
        } = selectedCountry;

        const { hreflangs = [], event } = this.props;
        const { location: { search } = {} } = history || {};
        const hrefLangPath = hreflangs?.find((hreflang) => hreflang.store_id === store_id) || url;

        const redirectUrl = `${hrefLangPath?.url}${search}`;

        if (locale) {
            event(EVENT_WELCOME_PAGE_REDIRECT, { redirectCode: code });
            setCookie(CURRENT_COUNTRY, code, COOKIE_LIFETIME);
            const url = new URL(redirectUrl);
            url.searchParams.append(NO_REDIRECT, true);
            window
                .location
                .assign(url.href);
        }
    }

    onRedirect(redirectUrl, redirectCode) {
        const { event, redirectCountry: { code } } = this.props;

        event(EVENT_WELCOME_PAGE_OTHER_REDIRECT, { redirectCode, geoIpCode: code });
        const url = new URL(redirectUrl);
        url.searchParams.append(NO_REDIRECT, true);
        window
            .location
            .assign(url.href);
    }

    setDesiredCountry() {
        this.setState({ isShowPopUp: false });
        const { event } = this.props;
        const base_url = window.location.origin;
        const pathArray = window.location.pathname.split('/');
        const isComSubdomain = base_url.endsWith(DOT_COM) && EXCLUDED_DOT_COM_STORES.includes(pathArray[1]);

        if (isComSubdomain) {
            setCookie(COM_SUB_STORE, pathArray[1], COOKIE_LIFETIME);
        } else {
            setCookie(NO_REDIRECT, true, COOKIE_LIFETIME);
        }

        event(EVENT_WELCOME_PAGE_NO_REDIRECT, {});
        closePopup(STORE_REDIRECT_POPUP, {});
    }

    render() {
        return (
            <StoreRedirect
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(StoreRedirectContainer);
